"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OracleLoadingSpinner = void 0;
var react_1 = __importStar(require("react"));
var getOracleComputedStyle_1 = require("./getOracleComputedStyle");
var OracleLoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 40 : _b, circleColor = _a.circleColor, progressColor = _a.progressColor, _c = _a.weight, weight = _c === void 0 ? 4 : _c, _d = _a.gap, gap = _d === void 0 ? 0.5 : _d, _e = _a.duration, duration = _e === void 0 ? 5000 : _e, _f = _a.className, className = _f === void 0 ? '' : _f;
    var _g = (0, react_1.useState)(0), progressAngle = _g[0], setProgressAngle = _g[1];
    // Use CSS variables if not provided as props
    var finalCircleColor = circleColor || (0, getOracleComputedStyle_1.getOracleColor)('--oracle-accent-light', 'oracle-p20');
    var finalProgressColor = progressColor || (0, getOracleComputedStyle_1.getOracleColor)('--oracle-p60', 'oracle-p60');
    // Calculate SVG properties
    var center = size / 2;
    var radius = (size - weight) / 2;
    // Helper function: Convert polar coordinates to cartesian
    var polarToCartesian = function (centerX, centerY, rad, angleInRadians) {
        return {
            x: centerX + (rad * Math.cos(angleInRadians - Math.PI / 2)), // -π/2 to start at top
            y: centerY + (rad * Math.sin(angleInRadians - Math.PI / 2)),
        };
    };
    // Helper function: Generate SVG arc path
    var describeArc = function (x, y, rad, startAngle, endAngle) {
        // Normalize angles
        var normalizedStart = startAngle % (2 * Math.PI);
        var normalizedEnd = endAngle % (2 * Math.PI);
        // If the arc length is very small, return empty path
        var arcLength = normalizedEnd >= normalizedStart
            ? normalizedEnd - normalizedStart
            : (2 * Math.PI) - normalizedStart + normalizedEnd;
        if (arcLength < 0.01)
            return ''; // Too small to render
        var start = polarToCartesian(x, y, rad, normalizedStart);
        var end = polarToCartesian(x, y, rad, normalizedEnd);
        var largeArcFlag = arcLength <= Math.PI ? '0' : '1';
        return [
            'M', start.x, start.y,
            'A', radius, radius, 0, largeArcFlag, 1, end.x, end.y,
        ].join(' ');
    };
    // Calculate current progress angle (ø) from 0 to 2π
    var phi = progressAngle * 2 * Math.PI;
    // Calculate angular extents based on your whiteboard math
    // Progress arc: from [g/2] to [ø]
    var progStartAngle = gap / 2;
    var progEndAngle = phi;
    var progArcLength = phi - gap / 2;
    // Circle arc: from [ø + g] to [2π - g/2]
    var circStartAngle = phi + gap;
    var circEndAngle = 2 * Math.PI - gap / 2;
    var circArcLength = 2 * Math.PI - phi - ((3 * gap) / 2);
    // Generate SVG paths
    var progressPath = progArcLength > 0 ? describeArc(center, center, radius, progStartAngle, progEndAngle) : '';
    var circlePath = circArcLength > 0 ? describeArc(center, center, radius, circStartAngle, circEndAngle) : '';
    // Animation effect - continuous loop
    (0, react_1.useEffect)(function () {
        var animationId;
        var animate = function () {
            var startTime = Date.now();
            var updateProgress = function () {
                var elapsed = Date.now() - startTime;
                var progress = (elapsed % duration) / duration; // Loop continuously
                setProgressAngle(progress);
                animationId = requestAnimationFrame(updateProgress);
            };
            updateProgress();
        };
        animate();
        return function () {
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        };
    }, [duration]);
    return (react_1.default.createElement("div", { className: "oracle-loading-spinner ".concat(className), style: {
            width: size,
            height: size,
        } },
        react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 ".concat(size, " ").concat(size), className: "oracle-loading-spinner__svg" },
            circlePath && (react_1.default.createElement("path", { d: circlePath, fill: "none", stroke: finalCircleColor, strokeWidth: weight, strokeLinecap: "round", className: "oracle-loading-spinner__background" })),
            progressPath && (react_1.default.createElement("path", { d: progressPath, fill: "none", stroke: finalProgressColor, strokeWidth: weight, strokeLinecap: "round", className: "oracle-loading-spinner__progress" })))));
};
exports.OracleLoadingSpinner = OracleLoadingSpinner;
